export const ChartDimensions = {
    value: "value",
    key: "key",
} as const satisfies Record<string, string>;
